<template>
  <section>
    <div
      v-if="isSubmitted"
      class="confirmation"
    >
      <ul>
        <confirmation-message
          :success="isSuccess"
          :email="emailSubmitted"
          :error="errorMessage"
        />
      </ul>
    </div>
    <section
      v-else
      class="identification"
    >
      <div class="identification__row__title">
        <h2>{{ $t('commons.connection.sign-in.mainTitle') }}</h2>
      </div>
      <div class="identification__row__body">
        <sign-in />
        <sign-up v-if="isLightSignUp" />
        <section v-else>
          <create-account-message
            signup-type="quotation"
            class-name="signup-full-message"
          />
        </section>
      </div>
    </section>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import vehicleCard from '../shared/mixins/vehicleCards'

export default {
  mixins: [vehicleCard],
  components: {
    vehicleCard,
    SignIn: () => import(/* webpackChunkName: "identification"  */ `./SignIn`),
    SignUp: () => import(/* webpackChunkName: "identification"  */ `./SignUp`),
    ConfirmationMessage: () => import(/* webpackChunkName: "identification"  */ `./ConfirmationMessage`),
    CreateAccountMessage: () => import(/* webpackChunkName: "identification"  */ `../shared/CreateAccountMessage`),
  },
  mounted() {
    this.$store.commit('stepping/SET_CURRENT_STEP', 3)
  },
  computed: {
    ...mapState({
      isSubmitted: (state) => state.registration.individual.isSubmitted,
      isSuccess: (state) => state.registration.individual.isSuccess,
      emailSubmitted: (state) => state.registration.individual.emailSubmitted,
      errorMessage: (state) => state.registration.individual.errorMessage,
      isLightSignUp: (state) => state.stepping.isLightSignUp,
      quotation: (state) => state.quotation,
      vehicle: (s) => s.vehicles.set.storeVehicle,
      business: (s) => s.booking,
    }),
    ...mapGetters({
      userIsLogged: 'auth/userIsLogged',
      isProfileRequested: 'user/isGetProfileRequested',
    }),
    isReadyForGTMGeneration() {
      this.analytics()
      return this.vehicle.id !== undefined && this.isProfileRequested !== undefined;
    },
    vehiclePrice() {
      return this.$store.state.vehicles.prices.allPrices[
        [this.vehicle.semi_clair]
      ]
    },
  },
  methods: {
    analytics() {
      if (!window.dataLayer) {
        return
      }
      const eeAction = 'eeCheckout'
      const checkoutStep = 2
      const containerId = window.renaultRent.gtm_id
      const departureAgency = this.business?.pickUp?.business?.label
      const returnAgency = this.business?.drop?.business?.label
      const loginStatus = this.isProfileRequested ? this.userIsLogged : 'N/A'
      const page = window.location.href
      const pageCategory = ''
      const pageTitle = document.querySelector('head title')?.text

      const products = [{
        brand: 'Renault',
        category: this.vehicle?.type.label === 'VP' ? 'tourism' : 'utilitaire',
        /* eslint-disable-next-line camelcase */
        id: this.vehicle?.semi_clair,
        name: this.vehicle?.label,
        /* eslint-disable-next-line camelcase */
        price: this.vehiclePrice?.price_per_day,
        /* eslint-disable-next-line camelcase */
        priceOnline: parseFloat(this.vehiclePrice?.total_no_discount?.value),
        /* eslint-disable-next-line camelcase */
        priceAgency: parseFloat(this.vehiclePrice?.total_ttc?.value),
        productCoupon: this.quotation?.pdfValidPromoCode ? this.quotation?.coupon : '',
        checkoutOption: this.isLightSignUp ? 'Agence' : 'En ligne',
        quantity: 1,
        variant: '',
      }]
      const payload = {
        eeAction,
        checkoutStep,
        containerId,
        departureAgency,
        loginStatus,
        page,
        pageCategory,
        pageTitle,
        returnAgency,
        products,
      }
      // console.log(payload)
      window.dataLayer.push(payload)
    },
  },
}
</script>

<style lang="scss" scoped>

.identification {
  align-content: center;
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  padding: 0 30px;

  @include teq-breakpoint($wide) {
    padding: 0;
  }

  &__row {
    display: flex;
    flex-direction: column;

    &__title {
      display: flex;
      flex-direction: column;
      margin-top: 17px;
      width: 100%;

      @include teq-breakpoint($medium) {
        max-width: calc(100% - 186px);
      }
    }

    &__body {
      align-content: flex-start;
      display: flex;
      flex: 1;
      flex-direction: column;
      width: 100%;

      @include teq-breakpoint($medium) {
        max-width: calc(100% - 186px);
      }

      > section {
        @include shared-forms();

        align-content: flex-start;
        display: flex;
        flex: 1;
        margin-bottom: 20px;

        @include teq-breakpoint($wide) {
          &:nth-child(odd) {
            margin-right: 10px;
          }

          &:nth-child(even) {
            margin-left: 10px;
          }
        }
      }

      .signup-full-message ::v-deep {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px;

        h4 {
          color: $black;
          font-family: $f-graphie-book;
          font-size: 2.2rem;
        }

        h4 {
          margin: 0 0 20px;
          text-align: center;
        }

        h5 {
          margin: 0 0 20px;
          text-align: center;
        }

        b {
          font-family: $f-graphie-bold;
          font-size: 1.3rem;
          margin: 0 0 10px;
        }

        li {
          @include font-size(12px);

          line-height: 12px;
          list-style-type: none;
          margin: 0 0 15px 15px;

          &::before {
            color: $broom;
            content: "• ";
          }
        }

        button {
          flex-grow: 0;
        }
      }

      @include teq-breakpoint($wide) {
        flex-direction: row;
      }
    }
  }
}

.confirmation {
  display: flex;
  flex: 1;
  justify-content: center;
}
</style>
